import { Box } from '@wix/design-system';
import { DomainSearchSuiteModule, Statuses } from '@wix/domains-search-suite';
import React from 'react';
import { FAQs } from '../../Components/FAQs';
import { AccountGateHeader } from '../../Components/Headers/AccountGateHeader';
import { MoreTools } from '../../Components/MoreTools';
import { SocialProofCard } from '../../Components/SocialProofCard';
import { TldPromotionsWithPrice } from '../../Components/TldPromotionsWithPrice';
import { AccountVoucherBanner } from '../../Components/VoucherBanner/AccountVoucherBanner';
import { useDomainSearchGateBi } from '../../hooks/useDomainSearchGateBi';
import { useQuerySubmit } from '../../hooks/useQuerySubmit';
import { useSuggestedTldPrices } from '../../hooks/useSuggestedTldPrices';
import { prefetchRecommendations } from '../../hooks/useRecommendations';
import { useViewTransition } from '../../hooks/useViewTransition';
import s from '../SearchGateHome/searchGateHome.scss';
import transition from '../viewTransitions.css';
import { ViewMode } from '../../types';
import { useGatePageBackground } from '../../hooks/useGatePageBackground';
import { useIsBmHarmonyThemeEnabled } from '../../utils/harmonyTheme';
import { HarmonyThemeProvider } from '@wix/core-domain-search';
const AccountLevelGateContent = _ref => {
  let hideBackButton = _ref.hideBackButton;
  useSuggestedTldPrices();
  const _useViewTransition = useViewTransition(),
    navigateBack = _useViewTransition.navigateBack,
    navigateTo = _useViewTransition.navigateTo;
  const pageBackground = useGatePageBackground();
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.SDK.hooks.useUrlRecovery(),
    getUrlState = _DomainSearchSuiteMod.getUrlState;
  useDomainSearchGateBi({
    viewMode: ViewMode.ACCOUNT_LEVEL_GATE
  });
  useQuerySubmit({});
  return /*#__PURE__*/React.createElement(Box, {
    padding: "16px 24px",
    direction: "vertical",
    gap: "SP4",
    align: "center",
    width: "100%",
    overflow: "auto",
    backgroundColor: pageBackground,
    scrollBehavior: "smooth",
    height: "100%",
    display: "grid",
    gridTemplateRows: "max-content max-content 1fr",
    gridTemplateAreas: " \"banner\" \"header\" \"content\" "
  }, /*#__PURE__*/React.createElement("section", {
    className: s.voucherBannerContainer
  }, /*#__PURE__*/React.createElement(AccountVoucherBanner, null)), /*#__PURE__*/React.createElement("header", {
    className: s.header
  }, /*#__PURE__*/React.createElement(Box, {
    align: "center",
    borderRadius: "12px",
    width: "100%",
    direction: "vertical",
    gap: "SP4",
    boxSizing: "border-box",
    padding: "24px 32px 48px",
    backgroundColor: "#E2D8FF",
    overflow: "hidden",
    zIndex: 1
  }, /*#__PURE__*/React.createElement(AccountGateHeader, {
    titleKey: "domains_search_gate.account_level.gate.title",
    onBackClick: hideBackButton ? undefined : () => {
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'back_button'
      });
      navigateBack();
    },
    className: transition.header
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%'
    },
    className: transition.searchBar
  }, /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.DomainSearchBar, {
    autoFocus: false,
    onFiltersChange: (key, value) => {
      if (key === 'tlds') {
        DomainSearchSuiteModule.internals.bi.onSelectTld == null || DomainSearchSuiteModule.internals.bi.onSelectTld({
          tld: JSON.stringify(value)
        });
      } else {
        DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
          ctaClick: key,
          value: JSON.stringify(value)
        });
      }
    },
    onSubmit: filters => {
      prefetchRecommendations();
      setTimeout(() => {
        const searchParams = getUrlState(filters);
        navigateTo(`/results?${searchParams}`);
      }, 500);
    }
  })))), /*#__PURE__*/React.createElement("main", {
    className: transition.content,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4",
    display: "grid",
    className: s.content,
    gridTemplateRows: "repeat(max-content, auto)"
  }, /*#__PURE__*/React.createElement(SocialProofCard, null), /*#__PURE__*/React.createElement(TldPromotionsWithPrice, null), /*#__PURE__*/React.createElement(MoreTools, null), /*#__PURE__*/React.createElement(FAQs, {
    onToggle: index => {
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'asked_questions',
        value: JSON.stringify(index)
      });
    }
  }))));
};
export const AccountLevelGate = _ref2 => {
  let handlers = _ref2.handlers,
    hideBackButton = _ref2.hideBackButton;
  const isHarmonyTheme = useIsBmHarmonyThemeEnabled();
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      enabledActions: [],
      handlers,
      siteInfo: {
        externalViewer: false
      },
      statusesOverrides: {
        transfer: Statuses.connect
      }
    }
  }, /*#__PURE__*/React.createElement(HarmonyThemeProvider, {
    enabled: isHarmonyTheme
  }, /*#__PURE__*/React.createElement(AccountLevelGateContent, {
    hideBackButton: hideBackButton
  })));
};
//# sourceMappingURL=AccountLevelGate.js.map